module.exports = __webpack_public_path__ + "static/media/logo.49149948.png";